import React from "react";
import Pagination from "react-bootstrap/Pagination";

const PaginationComponent = ({ currentPage, totalPages, onPageChange, totalEntries, entriesPerPage }) => {

    const adjustedCurrentPage = currentPage + 1;
    const totalPageNumbers = Array.from({ length: totalPages }, (_, i) => i + 1);

    const handlePageClick = (page) => {
        if (page !== adjustedCurrentPage) {
            onPageChange(page - 1);
        }
    }; 

    const startEntry = (adjustedCurrentPage - 1) * entriesPerPage + 1;
    const endEntry = Math.min(adjustedCurrentPage * entriesPerPage, totalEntries);

    return (
        <div className="pagination-section">
            <div className="showing-user">
                <p>
                    Showing {startEntry} to {endEntry} of {totalEntries} entries
                </p>
            </div>
            <div className="pagination-block">
                <Pagination>
                    <Pagination.First
                        onClick={() => handlePageClick(1)}
                        disabled={adjustedCurrentPage === 1}
                    />
                    <Pagination.Prev
                        onClick={() => handlePageClick(adjustedCurrentPage - 1)}
                        disabled={adjustedCurrentPage === 1}
                    />
                    {totalPageNumbers.map((page) => (
                        <Pagination.Item
                            key={page}
                            active={page === adjustedCurrentPage}
                            onClick={() => handlePageClick(page)}
                        >
                            {page}
                        </Pagination.Item>
                    ))}
                    <Pagination.Next
                        onClick={() => handlePageClick(adjustedCurrentPage + 1)}
                        disabled={adjustedCurrentPage === totalPages}
                    />
                    <Pagination.Last
                        onClick={() => handlePageClick(totalPages)}
                        disabled={adjustedCurrentPage === totalPages}
                    />
                </Pagination>
            </div>
        </div>
    );
};

export default PaginationComponent;



// <div className="pagination-section">
//                       <div className="showing-user">
//                         <p>Showing 1 to 10 of 50 entries</p>
//                       </div>
//                       <div className="pagination-block">
//                         <Pagination>
//                           {/* <Pagination.First /> */}
//                           <Pagination.Prev />
//                           <Pagination.Item>{1}</Pagination.Item>
//                           <Pagination.Item>{2}</Pagination.Item>
//                           <Pagination.Item active>{3}</Pagination.Item>
//                           <Pagination.Item>{4}</Pagination.Item>
//                           <Pagination.Item>{5}</Pagination.Item>
//                           <Pagination.Next />
//                           {/* <Pagination.Last /> */}
//                         </Pagination>
//                       </div>
//                     </div>